module.exports = __webpack_public_path__ + "img/face27.47556db7.gif";